import { BsHandbag } from "react-icons/bs";
import { AiOutlineArrowUp, AiOutlineArrowDown } from "react-icons/ai";

// Compact formatter (K, M, B, T). Handles negatives, strips trailing zeros.
export function compactNumber(value, { decimals = 1, locale = "en" } = {}) {
  if (value === "N/A") return "N/A";
  if (value == null || isNaN(value)) return "0";
  const abs = Math.abs(value);

  if (abs < 100000) return Number(value).toLocaleString(locale);

  const units = [
    { v: 1e12, s: "T" },
    { v: 1e9, s: "B" },
    { v: 1e6, s: "M" },
    { v: 1e3, s: "K" },
  ];

  const u = units.find((u) => abs >= u.v) || units[units.length - 1];
  const n = value / u.v;

  // Round & remove trailing zeros (e.g., 1.0K -> 1K, 1.50K -> 1.5K)
  const rounded = n.toFixed(decimals).replace(/\.0+$|(\.\d*[1-9])0+$/, "$1");

  return `${rounded}${u.s}`;
}

const DashboardCard = ({ data, icon, iconColor, bgColor, currency = null }) => {
  return (
    <>
      <div className='dashboardCardAc8'>
        <div className='iconTitle44'>
          <span style={{ backgroundColor: bgColor }}>{icon}</span> <span>{data.title}</span>
        </div>
        <p>
          {currency && data.amount !== "N/A" && currency}
          {compactNumber(data.amount, { decimals: 2 })}
        </p>
        <div>
          <span>+ 5,45%</span>{" "}
          <span>
            {" "}
            <AiOutlineArrowUp color='#97C9C4' />
            <AiOutlineArrowDown color='red' />
          </span>
        </div>
      </div>
    </>
  );
};

export default DashboardCard;
